var _rect, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApprovedToday(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#DDFFEF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62_3048",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00B55E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_62_3048)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1667 7.04175C17.5203 7.04175 15.375 9.18705 15.375 11.8334C15.375 14.4797 17.5203 16.6251 20.1667 16.6251C22.813 16.6251 24.9583 14.4797 24.9583 11.8334C24.9583 9.18705 22.813 7.04175 20.1667 7.04175ZM22.042 11.1727C22.3673 11.0575 22.5378 10.7003 22.4225 10.3749C22.3073 10.0496 21.9501 9.87921 21.6247 9.99444C21.2229 10.1367 20.8499 10.4033 20.5342 10.6801C20.2122 10.9626 19.9136 11.2882 19.6622 11.5895C19.5404 11.7355 19.4279 11.8779 19.3273 12.01C19.2538 11.9412 19.1802 11.8831 19.1071 11.8344L19.1028 11.8315C18.9708 11.7435 18.7935 11.6252 18.5 11.6252C18.1548 11.6252 17.875 11.9051 17.875 12.2502C17.875 12.5625 18.104 12.8213 18.4032 12.8678C18.4497 12.8987 18.6031 13.0206 18.7743 13.3631C18.8751 13.5646 19.0764 13.6962 19.3013 13.7078C19.5263 13.7193 19.7402 13.6086 19.861 13.4185C19.9967 13.2263 20.3967 12.6604 20.6221 12.3902C20.8487 12.1186 21.1016 11.8452 21.3585 11.6199C21.6219 11.3889 21.8555 11.2388 22.042 11.1727Z",
    fill: "#00973C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4853 7.04245C15.05 8.14702 14.125 9.8822 14.125 11.8334C14.125 15.1702 16.8299 17.8751 20.1666 17.8751C21.3104 17.8751 22.3799 17.5572 23.2916 17.0052V17.7162C23.2916 19.2456 23.2916 20.4607 23.1562 21.4124C23.0161 22.3962 22.7205 23.1896 22.062 23.8115C21.4086 24.4286 20.5834 24.7013 19.5593 24.8314C18.5588 24.9584 17.2784 24.9584 15.6527 24.9584H14.6805C13.0548 24.9584 11.7745 24.9584 10.774 24.8314C9.74985 24.7013 8.92467 24.4286 8.27123 23.8115C7.61274 23.1896 7.31713 22.3962 7.17708 21.4124C7.0416 20.4607 7.04161 19.2456 7.04163 17.7162V14.284C7.04161 12.7546 7.0416 11.5395 7.17708 10.5878C7.31713 9.60398 7.61274 8.81057 8.27123 8.18867C8.92467 7.57154 9.74985 7.29881 10.774 7.16876C11.7745 7.04173 13.0548 7.04174 14.6805 7.04175H15.6527C15.941 7.04175 16.2184 7.04175 16.4853 7.04245Z",
    fill: "#85D5A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1666 16.8333C10.1666 16.3731 10.5397 16 11 16H13.5902C14.0504 16 14.4235 16.3731 14.4235 16.8333C14.4235 17.2936 14.0504 17.6667 13.5902 17.6667H11C10.5397 17.6667 10.1666 17.2936 10.1666 16.8333Z",
    fill: "#00973C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1666 20.1666C10.1666 19.7063 10.5397 19.3333 11 19.3333H17.6666C18.1269 19.3333 18.5 19.7063 18.5 20.1666C18.5 20.6268 18.1269 20.9999 17.6666 20.9999H11C10.5397 20.9999 10.1666 20.6268 10.1666 20.1666Z",
    fill: "#00973C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedToday);
export default __webpack_public_path__ + "static/media/ApprovedToday.e42776c9ab6011065cfce75b2242c4e3.svg";
export { ForwardRef as ReactComponent };